<template>
  <v-page page="assetImport" title="Asset Import">
    <v-container>
      <v-layout column>
        <v-flex sm6>
          <v-layout>
            <v-flex xs2 class="mr-2">
              <v-select v-model="searchType"
                        :items="searchTypeChoices"
                        solo></v-select>
            </v-flex>
            <v-flex sm6>
              <v-text-field v-model="query"
                            placeholder="Search"
                            clearable solo
                            @keydown.enter="searchTypeSelection"
                            data-test="searchInput">
              </v-text-field>
            </v-flex>
            <v-flex xs2 class="ml-2">
              <v-select v-model="attribute"
                        :items="attributeChoices"
                        solo>
              </v-select>
            </v-flex>
            <v-flex class="searchbar-btn" xs2 lg1 ml-2>
              <v-btn @click="searchTypeSelection" color="primary">Search</v-btn>
            </v-flex>
          </v-layout>
          <v-card>
            <v-flex>
              <v-subheader>
                <strong>CURRENT ENV</strong>
              </v-subheader>
              <v-data-table
                class="elevation-1"
                :headers="tableHeaders"
                :items="existingAssets"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc">
                  <template v-slot:item="props">
                    <tr>
                      <td>{{ props.item.id }}</td>
                      <td>{{ props.item.filename }}</td>
                      <td>{{ props.item.sha }}</td>
                      <td>{{ props.item.mime_type }}</td>
                      <td>{{ props.item.is_secure | booleanYesNo }}</td>
                      <td>{{ props.item.created_at | dateTime }}</td>
                      <td>{{ props.item.updated_at | dateTime }}</td>
                      <td>{{ props.item.promoted_at | dateTime }}</td>
                      <td><a :href="props.item.url" target="assetPreview">Preview</a></td>
                    </tr>
                  </template>
              </v-data-table>
            </v-flex>
          </v-card>
        </v-flex>
     <v-layout column ml-3 pr-4>
        <v-layout>
          <v-flex>
          </v-flex>
          <v-flex mt-2 mb-2>
            <v-icon :color="uploadButtonColor" large>
              {{ upArrowIcon }}
            </v-icon>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-card>
            <v-flex>
              <v-subheader>
                <strong>LOWER ENV</strong>
              </v-subheader>
              <v-data-table
                class="elevation-1"
                :headers="tableHeaders"
                :items="promotableAssets"
                show-select
                v-model="selected"
                item-key="id"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc">
                <template v-slot:item="props">
                  <tr :active="props.selected" @click="rowSelected(props)">
                    <th>
                      <v-checkbox
                        :input-value="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </th>
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.filename }}</td>
                    <td>{{ props.item.sha }}</td>
                    <td>{{ props.item.mime_type }}</td>
                    <td>{{ props.item.is_secure | booleanYesNo }}</td>
                    <td>{{ props.item.created_at | dateTime }}</td>
                    <td>{{ props.item.updated_at | dateTime }}</td>
                    <td>{{ props.item.promoted_at | dateTime }}</td>
                    <td><a :href="props.item.url" target="assetPreview">Preview</a></td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout ml-3 mt-3 right>
      <v-flex mt-2>
        <v-btn
          :color="uploadButtonColor"
          @click="importAssets()">
          <v-icon left>
            {{ uploadButtonIcon }}
          </v-icon>
            {{ uploadButtonText }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex mt-3 sm8>
        <v-subheader :hidden="this.selected.length === 0">
          File Tags
        </v-subheader>
        <v-flex ml-5>
          <div
            v-for="(tagField, i) in tagFields"
            :key="i"
            class="text-fields-row">
              <v-layout sm-4>
                <v-flex mr-5 pr-3>
                  <v-text-field
                    :label="tagField.nameLabel"
                    v-model="tagField.tagName"
                    disabled>
                  </v-text-field>
                </v-flex>
                <v-flex mr-3>
                  <v-text-field
                    :label="tagField.valueLabel"
                    v-model="tagField.tagValue"
                    disabled>
                  </v-text-field>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>
<script>
import VPage from '@/layouts/Default'
import { Bus } from '@/bus'

export default {
  name: 'AssetImport',
  components: {
    VPage
  },
  props: {
    uploadButtonText: {
      type: String,
      default: 'Import File'
    },
    uploadButtonIcon: {
      default: 'cloud_upload'
    },
    uploadButtonColor: {
      default: 'primary'
    },
    upArrowIcon: {
      default: 'merge_type'
    }
  },
  data () {
    return {
      hint: 'Filename',
      attribute: 'tags',
      attributeChoices: [
        { value: 'ids', text: 'Id' },
        { value: 'tags', text: 'Tags' }
      ],
      searchType: 'Current',
      searchTypeChoices: [
        { value: 'Current', text: 'Current' },
        { value: 'Lower', text: 'Lower' }
      ],
      query: '',
      sortBy: 'id',
      sortDesc: true,
      selected: [],
      tagFields: [],
      promotableAssets: [],
      existingAssets: [],
      loading: false,
      tableHeaders: [
        { text: 'Asset Id', value: 'id', sortable: true },
        { text: 'Filename', value: 'filename', sortable: true },
        { text: 'Storage Filename', value: 'sha', sortable: true },
        { text: 'Mimetype', value: 'mime_type', sortable: true },
        { text: 'Is Secure', value: 'is_secure', sortable: true },
        { text: 'Created At', value: 'created_at', sortable: true },
        { text: 'Updated At', value: 'updated_at', sortable: true },
        { text: 'Promoted At', value: 'promoted_at', sortable: true },
        { text: 'Url', value: 'url' }
      ]
    }
  },
  computed: {
    inputRef () {
      return `file-input-${this._uid}`
    },
    buttonRef () {
      return `file-button-${this._uid}`
    }
  },
  mounted () {
    this.getImportAssets()
    this.getFileReferences()
  },
  methods: {
    searchTypeSelection () {
      this.searchType === 'Lower' ? this.getImportAssets() : this.getFileReferences()
    },
    rowSelected (props) {
      this.clearFields()
      if (props.selected) {
        this.$set(props, 'selected', !props.selected)
        if (this.selected.length > 0) {
          for (var property in this.selected[this.selected.length - 1].tags) {
            for (var i = 0; i < this.selected[this.selected.length - 1].length; ++i) {
              this.addTagField(props.item.id, property, this.selected[this.selected.length - 1].tags[i])
            }
          }
        }
      } else {
        this.$set(props, 'selected', true)
        for (var tagProperty in props.item.tags) {
          props.item.tags[tagProperty].forEach((tagValue) => {
            this.addTagField(props.item.id, tagProperty, tagValue)
          })
        }
      }
    },
    clearFields () {
      this.tagFields = []
    },
    addTagField (tagId = null, tagName = '', tagValue = '') {
      this.tagFields.push({
        id: tagId,
        nameLabel: 'Tag Name',
        tagName: tagName,
        origTagName: tagName,
        valueLabel: 'Tag Value',
        tagValue: tagValue,
        origTagValue: tagValue
      })
    },
    async getFileReferences () {
      await this.$store.dispatch('assets/fetchAssets', this.attribute ? { type: this.attribute, values: this.query } : null).then((result) => {
        this.existingAssets = result['assets']
      })
        .catch(() => {
          Bus.$emit('alert', { color: 'error', message: 'Failed to retrieve current env assets' })
        })
    },
    async importAssets () {
      await this.$store.dispatch('assets/importStagedAssets', this.selected).then((result) => {
        Bus.$emit('alert', { color: 'success', message: 'Succesfully uploaded asset' })
      })
        .catch(() => {
          Bus.$emit('alert', { color: 'error', message: 'Failed to import asset' })
        })
    },
    async getImportAssets () {
      await this.$store.dispatch('assets/fetchPromotableAssets', this.attribute ? { type: this.attribute, values: this.query } : null).then((result) => {
        this.promotableAssets = result['data']['assets']
      })
        .catch(() => {
          Bus.$emit('alert', { color: 'error', message: 'Failed to retrieve importable assets' })
        })
    }
  }
}
</script>
<style lang="sass">
  .v-btn
    min-height: 45px
</style>
